import React, { useEffect, useState } from 'react'
import styles from './Dropdown.module.scss'
import ArrowDropdown from '../../img/IconComponents/ArrowDropdown'
import cn from 'classnames'
import Triangle from '../../img/IconComponents/Triangle'
import Overlay from '../Overlay/Overlay'
import { useTranslation } from 'react-i18next'
import { countries } from 'countries-list';
import { getNames } from 'i18n-iso-countries';
import { registerLocale } from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import de from 'i18n-iso-countries/langs/de.json';

const Dropdown = ({ value = 'Select country', onChange, error,disabled, greenBorder = false }) => {
  const { t } = useTranslation()
  registerLocale(localStorage.getItem('i18n') != "EN" ? de : en);

  const getAllCountries = () => {
    const allCountries = getNames(localStorage.getItem('i18n') != "EN" ? 'de' : 'en'); 
    
    let countriesArray = Object.keys(allCountries).map((countryCode) => ({
      code: countryCode,
      name: allCountries[countryCode],
    }));
    const excludedCountries = ['China', 'India', 'Nepal', 'Bangladesh', 'Bolivia', 'Ecuador', 'Algeria', 'North Macedonia', 'United States', 'North Korea', 'Iran', 'Syria', 'Cuba', 'Russia', 'Belarus', 'Germany', 'Austria', 'Switzerland'];

    const germany = { code: 'DE', name: localStorage.getItem('i18n') != "EN" ? 'Deutschland' : 'Germany' };
    const austria = { code: 'AT', name: localStorage.getItem('i18n') != "EN" ? 'Österreich' : 'Austria' };
    const switzerland = { code: 'CH', name: localStorage.getItem('i18n') != "EN" ? 'Schweiz' : 'Switzerland' };

    countriesArray = [germany, austria, switzerland, ...countriesArray.filter((country) => !excludedCountries.includes(country.name))];
    return countriesArray;
  };
  // console.log(sortedCountryList)

  // const dropdownData = [
  //   { country: t('Germany'), id: 11 },
  //   { country: t('Austria'), id: 1 },
  //   { country: t('Switzerland'), id: 28 },
  //   { country: t('Belgium'), id: 2 },
  //   { country: t('Bulgaria'), id: 3 },
  //   { country: t('Croatia'), id: 4 },
  //   { country: t('Cyprus'), id: 5 },
  //   { country: t('Czech Republic'), id: 6 },
  //   { country: t('Denmark'), id: 7 },
  //   { country: t('Estonia'), id: 8 },
  //   { country: t('Finland'), id: 9 },
  //   { country: t('France'), id: 10 },
  //   { country: t('Greece'), id: 12 },
  //   { country: t('Hungary'), id: 13 },
  //   { country: t('Ireland'), id: 14 },
  //   { country: t('Italy'), id: 15 },
  //   { country: t('Latvia'), id: 16 },
  //   { country: t('Lithuania'), id: 17 },
  //   { country: t('Luxembourg'), id: 18 },
  //   { country: t('Malta'), id: 19 },
  //   { country: t('Netherlands'), id: 20 },
  //   { country: t('Poland'), id: 21 },
  //   { country: t('Portugal'), id: 22 },
  //   { country: t('Romania'), id: 23 },
  //   { country: t('Slovakia'), id: 24 },
  //   { country: t('Slovenia'), id: 25 },
  //   { country: t('Spain'), id: 26 },
  //   { country: t('Sweden'), id: 27 },
  //   { country: t('United Kingdom'), id: 29 },
  //   { country: t('Select country'), id: 30 },
  // ]

  // const germany = sortedCountryList.filter(
  //   (el) => el.country === 'Germany' || el.country === 'Deutschland',
  // )
  // const restCountries = sortedCountryList.filter(
  //   (el) => el.country !== 'Germany' || el.country !== 'Deutschland',
  // )

  const [isOpen, setIsOpen] = useState(false)

  const setCountry = (country) => {
    setIsOpen(false)
    onChange(country)
  }

  const closeModalHandler = (e) => {
    if (e.target.className === 'overlay') {
      e.stopPropagation()
      setIsOpen(false)
    }
  }

  useEffect(() => {
    if (value) {
      onChange(value)
    }
  }, [value])


  return (
    <div className={styles.dropdown}>
      {isOpen ? <Overlay closeModalHandler={closeModalHandler} /> : null}
      <span className={styles.dropdown__label}>{t("Country")}</span>
      <div
        className={cn(styles.dropdown__inner, styles.dropdown__inner_border, error ? styles.dropdown__inner_border_red : '')}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div>{value && value.length ? t(`${value}`) : t('Select country')}</div>
        <ArrowDropdown />
      </div>
      {!disabled&&<>
      <div
        className={cn(
          styles.dropdown__block,
          isOpen ? styles.dropdown__block_active : '',
        )}
      >
        {/* <div
          className={styles.dropdown__block_value}
          key={sortedCountryList[0]}
          onClick={() => setCountry(sortedCountryList[0])}
        >
          {sortedCountryList[0]}
        </div> */}
        {getAllCountries()?.map((item) => {
          const {code, name} = item;
          return (
            <div
              className={styles.dropdown__block_value}
              key={`${code}`}
              onClick={() => setCountry(name)}
            >
              {name}
            </div>
          )
        })}
      </div></>}
      {error && error.length && (
        <div className={styles.dropdown__error}>
          <Triangle />
          <div>{error}</div>
        </div>
      )}
    </div>
  )
}

export default Dropdown
